<template>
  <sc-page-base
    :title="title"
    :loading="loading">

    <div class="box">
      <div id="viz-container"></div>
    </div>

  </sc-page-base>
</template>

<script>
  import { Url } from '@intelipost-js/secure-providers';
  import {
    ScPageBase,
    ScCard,
    ScIcon,
  } from '@intelipost-js/secure-components';
  import { createNamespacedHelpers } from 'vuex';

  const { mapActions } = createNamespacedHelpers('analytic/bi');

  export default {
    name: 'page-bi-reports',
    data() {
      return {
        loading: false,
        title: this.$route.params.title,
      };
    },
    methods: {
      generateReport() {
        const el = document.querySelector('#viz-container');

        const [
          workbookName,
          workbookType, //eslint-disable-line
          workbookTitle,
        ] = this.$route.params.url.split('/');

        const params = {
          ':embed': 'truey',
          ':showShareOptions': 'false',
          ':display_count': 'no',
          ':showVizHome': 'no',
        };

        const pathParams = [
          workbookName,
          workbookTitle,
        ];

        const url = Url.toQueryString('https://tableau.intelipost.com.br/t/intelipost/views', params, pathParams);

        const viz = new tableau.Viz(el, url, {//eslint-disable-line
          hideTabs: true,
          width: el.offsetWidth,
          height: 850,
          onFirstInteractive: () => {
            this.title = viz.getWorkbook().getActiveSheet().getName();
            this.loading = false;
          },
        });
      },
      ...mapActions([
        'getSessionReport',
      ]),
    },
    mounted() {
      this.loading = true;

      return this.getSessionReport()
        .then(() => this.generateReport());
    },
    components: {
      ScPageBase,
      ScCard,
      ScIcon,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/bi-reports/pages/bi-view/PageBiView.vue?6c20e57c